module.exports = __webpack_public_path__ + "img/test_week_ai.9f024989.jpg";